'use strict';

var _ = require('lodash');
var moment = require('moment');
var searchLocations = require('../enums/searchLocations');
var venueAdmin = require('../enums/venueAdmin');

exports.coverImage = function (venue) {
  if (_.get(venue, 'data.photos.length') && venue.data.photos.length >= venue.data.coverIndex) {
    return venue.data.photos[venue.data.coverIndex];
  }
  return venue.data.photos[0] || { url: 'http://res.cloudinary.com/dbwijvnzn/image/upload/v1453314075/placeholder_xj1wzt.jpg' };
};

exports.minimumMenuPriceCents = function (venue) {
  if (!_.get(venue, 'internal.menuPrices.length')) {
    return;
  }
  return _.minBy(venue.internal.menuPrices, function (price) {
    return price;
  });
};

exports.capacityRange = function (venue) {
  var minCapacity = null;
  var maxCapacity = null;

  var spaces = _.get(venue, 'data.spaces');
  _.each(spaces, function (space) {
    var seatedMin;
    var standingMin;
    var seatedMax;
    var standingMax;

    if (_.get(space, 'data.capacity.seated.selected')) {
      seatedMin = _.get(space, 'data.capacity.seated.min');
      seatedMax = _.get(space, 'data.capacity.seated.max');
    }

    if (_.get(space, 'data.capacity.standing.selected')) {
      standingMin = _.get(space, 'data.capacity.standing.min');
      standingMax = _.get(space, 'data.capacity.standing.max');
    }

    if (seatedMin != null && (minCapacity == null || seatedMin < minCapacity)) {
      minCapacity = seatedMin;
    }
    if (standingMin != null && (minCapacity == null || standingMin < minCapacity)) {
      minCapacity = standingMin;
    }

    if (seatedMax != null && (maxCapacity == null || seatedMax > maxCapacity)) {
      maxCapacity = seatedMax;
    }
    if (standingMax != null && (maxCapacity == null || standingMax > maxCapacity)) {
      maxCapacity = standingMax;
    }
  });

  return { min: minCapacity, max: maxCapacity };
};

/**
 * Determines if a venue has enough menus and drinks to be visible
 *
 * @param {Venue} venue
 * @param {Array} menus
 * @param {Array} drinks
 * @return {Boolean}
 */
exports.hasEnoughMenusAndDrinks = function (venue, menus, drinks) {
  if (!venue.isVisible) {
    return true;
  }
  var numVisibleMenus = _.filter(menus, function (menu) {
    return menu.isVisible;
  }).length;
  var numVisibleDrinks = _.filter(drinks, function (drink) {
    return drink.isVisible;
  }).length;

  return !!(numVisibleMenus + numVisibleDrinks);
};

exports.getNearbyMajorCity = function (venue) {
  for (var key in searchLocations) {
    var matchesAnchorCity = searchLocations[key].aliases.find(function (alias) {
      return alias.city === venue.data.address.city && alias.state === venue.data.address.state;
    });
    if (matchesAnchorCity) {
      return searchLocations[key].searchLocation;
    }
  }
  return 'OOM';
};

exports.publicUrl = function (venue, domain) {
  return domain + '/venue/' + venue.slug;
};

exports.privateUrl = function (venue, domain) {
  if (!['Private', 'Review'].includes(venue.status)) {
    return exports.publicUrl(venue, domain);
  }
  return domain + '/venue/' + venue.slug + '/private/' + _.get(venue, 'internal.uuid');
};

exports.getPublishedDate = function (venue) {
  if (!isVenuePartner(venue)) {
    return;
  }
  if (venue.status !== 'Published') {
    return;
  }
  var statusChanges = _.get(venue, 'internal.statusChanges', []);
  var firstChange = statusChanges.find(function (change) {
    return change.newValue === 'Published';
  });
  return firstChange && firstChange.time;
};

exports.isNewVenue = function (venue) {
  if (!isVenuePartner(venue)) {
    return false;
  }
  var publishedDate = exports.getPublishedDate(venue);
  if (publishedDate) {
    var diffDays = moment().diff(moment(publishedDate), 'days');
    return diffDays < venueAdmin.newVenueCutoff;
  }
};

exports.setLastBooking = function (venue) {
  venue.admin.lastBooking = Date.now();
  return venue;
};

exports.isBookingPriority = function (venue) {
  if (!isVenuePartner(venue)) {
    return false;
  }
  var lastBookingDate = venue.admin.lastBooking;

  if (!lastBookingDate) {
    return true;
  }
  var diffDays = moment().diff(moment(lastBookingDate), 'days');
  return diffDays > venueAdmin.bookingCutoff;
};

function isVenuePartner(venue) {
  return _.get(venue, 'admin.recoGuidance') === 'Venue Partner';
}

exports.isVenuePartner = isVenuePartner;

exports.getAuthorizedUsers = function (venue, preferences) {
  var allAuthorizedUsers = _.get(venue, 'authorizedUsers', []);
  if (!preferences) {
    return allAuthorizedUsers;
  }

  var preferencesToFilter = Object.keys(preferences);

  return allAuthorizedUsers.filter(function (user) {
    return preferencesToFilter.every(function (preference) {
      return user.preferences[preference] === preferences[preference];
    });
  });
};

exports.getAuthorizedUsersToEmail = function (venue) {
  var usersWithEnabledEmails = exports.getAuthorizedUsers(venue, { receiveEmails: true });
  if (!usersWithEnabledEmails.length) {
    return exports.getAuthorizedUsers(venue);
  } else {
    return usersWithEnabledEmails;
  }
};

exports.getAuthorizedUsersToDisplay = function (venue) {
  return exports.getAuthorizedUsers(venue, { displayOnProposals: true });
};

exports.getAuthorizedUsersForFinanceEmail = function (venue) {
  return exports.getAuthorizedUsers(venue, { receiveFinanceEmail: true });
};